<template>
  <div>
    <b-card class="mt-1">
      
      <b-row>
        <v-select class="col-2" v-model="form.tipoBusqueda" placeholder="Buscar por" :options="tipoBusquedaOpts"
          :reduce="option => option.value" label="text" />

        <v-select :disabled="!form.tipoBusqueda" v-model="form.tipoBusquedaQuery" @search="onSearch"
          :options="tipoBusquedaQueryOpts" placeholder="Buscar por nombres o apellidos" :reduce="option => option.value"
          label="text" class="col-4" />

        <flat-pickr class="form-control col-2 ml-1" v-model="form.fechaDesde" locale="es" placeholder="Desde" />

        <flat-pickr class="form-control col-2 ml-1" v-model="form.fechaHasta" locale="es" placeholder="Hasta" />
      </b-row>

      <b-row class="my-1">
        <v-select v-model="form.establecimiento" placeholder="Establecimiento" :options="establecimientoOpts" :disabled="true"
          :reduce="option => option.value" label="text" class="col-2" />

        <v-select v-model="form.tipoSeguro" :multiple="true" placeholder="Tipo seguro" :options="segurosSaludOpts"
          :reduce="option => option" label="text" class="col-3" />

        <v-select v-model="form.tipoCobertura" :multiple="true" placeholder="Tipo cobertura"
          :options="tipoCoberturaOpts" :reduce="option => option" label="text" class="col-2" />

        <v-select id="especialidad" v-model="form.especialidad" placeholder="Especialidad" :options="especialidadesOpts"
          :reduce="option => option" label="text" :multiple="true" class="col-3" />

        <v-select id="pservicio" v-model="form.tipoServicio" placeholder="Tipo Servicio" :options="tipoServicioOpts"
          :reduce="option => option" label="text" :multiple="true" class="col-2" />
      </b-row>

      <b-row class="mt-2">
        <b-col md="4">
          <b-button variant="primary" @click="generarArchivo">
            <span style="color: white">
              <i class="fa fa-cog" aria-hidden="true" />
              Generar 
            </span>
          </b-button>
         
        </b-col>
      </b-row>

    </b-card>
  <div>
      <PlanoTableComponent />
    </div>
  </div>
</template>

<script>

import { getCurrentDate } from "@/shared/helpers";

import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { generarArchivoPlano } from "../services/archivosPlanos";
import PlanoTableComponent from "./PlanoTableComponent.vue";
import axios from "axios";
import rutas    from '@/assets/utils/rutas.json';
import rutasrep from '@/assets/utils/rutas.json';


import { 
  loadEspecialidadesOpts, 
  loadTipoSegurosOpts, 
  loadTipoCoberturaOpts,
  loadTipoServiciosOpts,
  loadEstablecimientosOpts,
  loadDoctoresOpts,
  loadPacientesOpts
}   from "../helpers";
import { getEstablecimientoLS } from "../../../shared/helpers";

export default {

  name: "FormArchivoPlanoGenerate",

  components: {
    vSelect,
    flatPickr,
    PlanoTableComponent
  },

  data() {
    return {
      form:{
        tipoBusqueda : null,
        tipoBusquedaQuery: null,
        fechaDesde  : null,
        fechaHasta  : null,
        tipoSeguro   : [{ "value": "*", "text": "TODOS", "codigo": "*" }],
        tipoCobertura: [{ "value": "*", "text": "TODOS", "codigo": "*" }],
        especialidad : [{ "value": "*", "text": "TODOS", "codigo": "*" }],
        tipoServicio : [{ "value": "*", "text": "TODOS", "codigo": "*" }],
        establecimiento: null,
      },
      tipoBusquedaQueryOpts : [],
      segurosSaludOpts  : [],
      tipoCoberturaOpts : [],
      especialidadesOpts: [],
      tipoServicioOpts  : [],
      establecimientoOpts : [],
      tipoBusquedaOpts: [
        { text: "Doctor", value: 1 },
        { text: "Paciente", value: 2 },
        { text: "Todos Doctor", value: 3 },
        { text: "Todos Paciente", value: 4 }
      ],
    }
  },


  created() {
    this.loadDataInitForm();
    
  },

  methods: {

    
    async loadDataInitForm(){
      this.segurosSaludOpts   = await loadTipoSegurosOpts();
      this.tipoCoberturaOpts  = await loadTipoCoberturaOpts();
      this.especialidadesOpts = await loadEspecialidadesOpts();
      this.tipoServicioOpts   = await loadTipoServiciosOpts();
      this.establecimientoOpts = await loadEstablecimientosOpts();
      this.establecimientoOpts.push({text: "TODOS", unicode:"00000", value: "0"})
      this.form.establecimiento = getEstablecimientoLS().id
      
    },


    async generarArchivo(){
      const isValidForm = this.validateForm();
      if(!isValidForm) return;

      const variablesConsulta =  this.mapVariables();
      const response = await generarArchivoPlano( variablesConsulta );
      
      if(!response === 'success'){
        return;
      }
      await this.downloadPlanos(response.archivoplano.id)
      this.modalOk();
    },

    
    async downloadPlanos(id) {
      const query = `
        query MyQuery {
          archivoPlanoxls(aplanoid: ${id}) {
            xlsarchivo
            message
          }
        }
      `;    

      try {
        const response = await axios.post(rutasrep.axiosrep + 'api', { query });

      } catch (error) {
        console.log(error);
        
      }
    },


    validateForm(){
      const errors = [];
      const {  fechaDesde, fechaHasta, tipoSeguro, tipoCobertura, especialidad, tipoServicio } = this.form;

      if( fechaDesde === null )
        errors.push( 'Debe seleccionar la fecha desde' );

      if( fechaHasta === null )
        errors.push( 'Debe seleccionar la fecha hasta' );

      if( tipoSeguro.length === 0 )
        errors.push( 'Debe seleccionar el tipo seguro' );

      if( tipoCobertura.length === 0 )
        errors.push( 'Debe seleccionar el tipo cobertura' );

      if( especialidad.length === 0 )
        errors.push( 'Debe seleccionar la especialidad' );

      if( tipoServicio.length === 0 )
        errors.push( 'Debe seleccionar el tipo servicio' );

      if( errors.length === 0 ) return true;

      const mensajeError = errors.join( ',' );

      this.$swal({
        title: "Error",
        text: mensajeError,
        icon: "error",
        confirmButtonColor: "#089599",
      });

      return false;
    },


    mapVariables(){

      const { 
        tipoBusqueda, tipoBusquedaQuery, fechaDesde, fechaHasta,
        tipoSeguro, tipoCobertura, especialidad, tipoServicio, establecimiento
      } = this.form;

      const tipoSeguroMap    = tipoSeguro.map( item => item.value ).join(',');
      const tipoCoberturaMap = tipoCobertura.map( item => item.codigo ).join(',');
      const especialidadMap  = especialidad
        .map(item => (item.codigo ?? item.value ?? '').toString().trim())
        .filter(item => item !== '')
        .join(',');
      const tipoServicioMap  = tipoServicio.map( item => item.value ).join(',');

      return {
        iddoctor: tipoBusqueda === 1 ? tipoBusquedaQuery : "",
        idpaciente: tipoBusqueda === 2 ? tipoBusquedaQuery : "",
        establecimiento : establecimiento ? establecimiento : "",
        fechaproceso : getCurrentDate(),
        fechaDesde, fechaHasta,
        tiposeguro   : tipoSeguroMap, 
        tipocobertura: tipoCoberturaMap, 
        especialidad : especialidadMap, 
        pservicio    : tipoServicioMap
      };
    },

    async onSearch(searchTerm) {
      if (searchTerm.length > 3) {
        if (this.form.tipoBusqueda === 1) {
          console.log("entra doctor")
          try {
            let optDoc = [];
            let doctores = await loadDoctoresOpts(searchTerm);
            console.log("docs", doctores)
            optDoc = doctores.map(doc => ({
              value: doc.id,
              text: `${doc.idPersona.primerApellido} ${doc.idPersona.primerNombre} (${doc.idPersona.identificacion})`,
              identificacion: doc.idPersona.identificacion
            }));
            this.tipoBusquedaQueryOpts = optDoc;
          } catch (error) {
            console.error("Error loading doctor options:", error);
          }
        }

        else if (this.form.tipoBusqueda === 2) {
          console.log("entra paciente")

          try {
            let optPac = [];
            let pacientes = await loadPacientesOpts(searchTerm);
            optPac = pacientes.map(paciente => ({
              value: paciente.id,
              text: `${paciente.persona.primerApellido} ${paciente.persona.primerNombre} (${paciente.persona.identificacion})`,
              identificacion: paciente.persona.identificacion
            }));
            this.tipoBusquedaQueryOpts = optPac;
          } catch (error) {
            console.error("Error loading patient options:", error);
          }
        }
      }
    },

    modalOk(){
      this.$swal({
        title: "Exito",
        text: "Usuario admin, el archivo plano entra en proceso de generacion",
        icon: "success",
        confirmButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.go(0);
        }
      });
    }
  }, 

 
  

  
}
</script>
